<div class="head cce-row">
  <span>ARE YOU SURE YOU WANT TO LOGOUT?</span>
</div>
<div class="content cce-row">
  <button  class="blue"(click)="Logout()">LOGOUT</button>
  <button  class="gray" [mat-dialog-close]="true" >CANCEL</button>
</div>
